export default {
  namespaced: true,
  state: {
    isVisible: false
  },
  mutations: {
    SET_VISIBLE(state, { visible }) {
      state.isVisible = visible;
    },
  },
  actions: {
    show({ commit }) {
      commit('SET_VISIBLE', { visible: true });
    },
    hide({ commit }) {
      commit('SET_VISIBLE', { visible: false });
    },
  }
};
